import React, { useState, useEffect } from "react";
import { Button, IconButton } from "@mui/material";
import { IoIosCloseCircleOutline } from "react-icons/io";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

// {
//   "id": 9,
//   "description": "play time. ",
//   "name": "PLAY_TIME",
//   "textUz": "namoz vaqtlari",
//   "textRu": "время молитвы",
//   "textEn": "prayer time"
// }

const Editingmessage = ({ message, _callback, modal, setModal }) => {
  const [uzb, setUzb] = useState("");
  const [eng, setEng] = useState("");
  const [rus, setRus] = useState("");
  const [desc, setDesc] = useState("");
  // get data
  useEffect(() => {
    if (message) {
      setUzb(message.textUz);
      setEng(message.textEn);
      setRus(message.textRu);
      setDesc(message.description);
    }
  }, [message]);

  const submitHandler = () => {
    _callback(true, {
      id: message.id,
      description: desc,
      name: message.name,
      textUz: uzb,
      textRu: rus,
      textEn: eng,
    });
  };
  return (
    <div>
      {message ? (
        <Dialog
          open={modal}
          fullWidth
          maxWidth="md"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            className="d-flex justify-content-between align-items-center px-5"
          >
            <p>
              {message.firstName} {message.lastName}
            </p>
            <IconButton onClick={() => setModal(false)}>
              <IoIosCloseCircleOutline />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <h4>Редактирование сообщения</h4>
            <div className="w-100 p-3 ">
              <label className="">Russian</label>
              <input
                type="text"
                value={rus}
                onChange={(e) => setRus(e.target.value)}
              />
            </div>
            <div className="w-100 p-3 ">
              <label className="">English </label>
              <input
                type="text"
                value={eng}
                onChange={(e) => setEng(e.target.value)}
              />
            </div>
            <div className="w-100 p-3 ">
              <label className="">Uzbek </label>
              <input
                type="text"
                value={uzb}
                onChange={(e) => setUzb(e.target.value)}
              />
            </div>
            <div className="w-100 p-3 ">
              <label className="">Description</label>
              <textarea
                type="text"
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
              />
            </div>
          </DialogContent>
          <DialogActions className="px-5 pb-3">
            <Button onClick={submitHandler} variant="contained" color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}{" "}
    </div>
  );
};

export default Editingmessage;
